import React, { useEffect, useState } from 'react';
import { CircularProgress, Menu, MenuItem, Typography } from "@mui/material";
import { getTicketById, updateTicketById } from '../../actions/tickets';
import { useParams } from 'react-router-dom';
import { handleError, handleSuccess } from '../../helpers/utils';
import { timestampToNormalDateTime } from '../../helpers/hours';
import { Button, Col, Row } from 'react-bootstrap';
import { getDownloadURL, getStorage, listAll, ref } from 'firebase/storage';

export const TIcketDetail = () => {
    // Loading state
	const [isLoading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [openMenu, setOpenMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const { id = null } = useParams();
    const storage = getStorage();

    const [ticketInfo, setTicketInfo] = useState([]);

    const handleClickMenu = (event) => {
		setAnchorEl(event.currentTarget);
		setOpenMenu(true);
	};

    const handleCloseMenu = () => {
		setAnchorEl(null);
		setOpenMenu(false);
	};


    const fetchFiles = async () => {
        try {
            // Create a reference under which you want to list
            const folderRef = ref(storage, `tickets/${id}`);

            // Find all the prefixes and items.
            listAll(folderRef)
                .then(async(res) => {
                    const filesPromises = res.items.map(async (item) => {
                        const url = await getDownloadURL(item);
                        return { url, name: item.name };
                    });
                    const files = await Promise.all(filesPromises);
                    setFiles(files);
                }).catch((error) => {
                    console.log("🚀 ~ .then ~ error:", error)
                });
        } catch (error) {
            console.error('Error fetching files:', error);
        }
    };

    const getTicketInfo = () => {
        setLoading(true);

        getTicketById(id)
            .then((data) => {
                setTicketInfo(data?.data());
            })
            .catch((error) => {
                handleError(error, 'Error al obtener la información del ticket.');
            })
            .finally(() => {
                // Remove loading state
                setLoading(false);
            });
    };

    useEffect(() => {
        getTicketInfo();
        fetchFiles();
    }, []);

    const handleClickItemMenu = (newStatus) => {
        setLoading(true);
        updateTicketById(id, {...ticketInfo, status: newStatus})
            .then(data => {
                handleSuccess('Estatus actualizado');
                getTicketInfo();
                handleCloseMenu();
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                setLoading(false);
            })
	};

    return (
        <div>
            {isLoading ? (
				<center style={{ padding: '20%' }}>
					<CircularProgress />
				</center>
			) : (
                <div style={{padding: '40px'}}>
                    <Row>
                        <Col xs={10}>
                            <Typography variant='p'><b>Título</b></Typography><br/>
                            <Typography variant='h6'>{ticketInfo?.title}</Typography>
                        </Col>
                        <Col xs={2}>
                            <div>
                                <Button
                                    color='primary'
                                    onClick={handleClickMenu}
                                >
                                    Actualizar estatus
                                </Button>
                                    <Menu
                                        id='basic-menu'
                                        anchorEl={anchorEl}
                                        open={openMenu}
                                        onClose={handleCloseMenu}
                                        MenuListProps={{
                                            'aria-labelledby': 'basic-button',
                                        }}
                                    >
                                        <MenuItem
                                            disabled
                                        >
                                            Reportado
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => handleClickItemMenu('Rechazado')}
                                        >
                                            Rechazado
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => handleClickItemMenu('En proceso')}
                                        >
                                            En proceso
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => handleClickItemMenu('Finalizado')}
                                        >
                                            Finalizado
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => handleClickItemMenu('Cancelado')}
                                        >
                                            Cancelado
                                        </MenuItem>
                                    </Menu>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{marginTop: '20px'}}>
                        <Col xs={12} md={6}>
                            <Typography variant='p'><b>Reportado por</b></Typography><br/>
                            <Typography variant='p'>{ticketInfo?.reported_by?.name}</Typography>
                        </Col>
                        <Col xs={12} md={6}>
                            <Typography variant='p'><b>Fecha de creación</b></Typography><br/>
                            <Typography variant='p'>{timestampToNormalDateTime(ticketInfo?.created)}</Typography>
                        </Col>
                    </Row>
                    <Row style={{marginTop: '10px', marginBottom: '20px'}}>
                        <Col xs={12} md={6}>
                            <Typography variant='p'><b>Tipo</b></Typography><br/>
                            <Typography variant='p'>{ticketInfo?.type}</Typography>
                        </Col>
                        <Col xs={12} md={6}>
                            <Typography variant='p'><b>Estatus</b></Typography><br/>
                            <Typography variant='p'>{ticketInfo?.status}</Typography>
                        </Col>
                    </Row>


                    <Typography variant='p'><b>Descripción</b></Typography><br/>
                    <Typography variant='p'>{ticketInfo?.description}</Typography><br/><br/>
                    {files?.length >= 1 ? 
                        <>
                        <Typography variant='p' style={{marginTop: '20px'}}><b>Evidencias</b></Typography><br/>
                        <Row style={{marginBottom: '20px'}}>
                            {files?.map((file) => (
                                <Col xs={6} key={file.name} style={{alignItems: 'center', justifyContent: 'center', display: 'flex', padding: '20px'}}>
                                    {file.name.endsWith('.jpg') || file.name.endsWith('.jpeg') || file.name.endsWith('.png') ? (
                                        <img src={file.url} alt={file.name} style={{width: '100%'}}/>
                                    ) : null}
                                </Col>
                            ))}
                        </Row>
                        {files?.map((file) => (
                            !(file.name.endsWith('.jpg') || file.name.endsWith('.jpeg') || file.name.endsWith('.png')) ? (
                                <a href={file.url} target='_blank'>{file.name}</a>
                            ) : null
                        ))}
                        </>
                    : null}
                    
                </div>
            )}
        </div>
    );
}